import { Table } from '@/components/notification/table'

export const Index = () => {
  return (
    <>
      <div className="flex flex-col gap-12">
        <Table pageSize={15} onIndex />
      </div>
    </>
  )
}
